import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Section as commonSection,
  Wrapper as commonWrapper,
  Content as commonContent,
  Panel as commonPanel,
  PanelInner as commonPanelInner,
  Information as commonInformation,
  Text as commonText,
} from '../../assets/Common/Content.style';

import { Center as commonCenter } from '../../assets/Common/Center.style';

export const Section = styled.div`
  ${commonSection}
`;

export const Wrapper = styled.div`
  ${commonWrapper}
`;

export const Content = styled.div`
  ${commonContent}
  scroll-behavior: auto;
`;

export const Panel = styled.div`
  ${commonPanel}
`;

export const PanelInner = styled.div`
  ${commonPanelInner}
`;

export const Center = styled.div`
  ${commonCenter}
`;

export const Information = styled.div`
  ${commonInformation}
  max-width: 530px;
  text-align: center;
`;

export const Text = styled.p`
  ${commonText}
`;

export const Box = styled.div`
  display: block;
  max-width: 100%;
  width: 100%;
  padding: 60px 30px 30px;

  ${Media.lg`
    padding: 20px 0;
  `}
`;
